
<section class="uk-section uk-position-relative" style="background-color: #101010" uk-height-viewport>


    <div *ngIf="complete() == ''"></div>> 

	<div class="uk-container uk-container-xsmall uk-flex uk-flex-center" *ngIf="complete() != ''">
		<div class="uk-text-center uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
			<div class="uk-padding header">
				<img src="/assets/images/logo-mazda.jpg" alt="Mazda Premium Insurance" width="220">
			</div>    
            <div *ngIf="complete() == 'true'">
                <h2 class="uk-flex uk-flex-center uk-text-bold" style="color: white;">สมัครใช้บริการสำเร็จ</h2>
                <!-- <div class="uk-flex uk-flex-center" *ngFor="let body of content.body">
                <p class="uk-form-label uk-width-3-4">{{ body }}</p>
                </div> -->
        
                <div class="uk-flex uk-flex-center">
                <h4 class="uk-text" style="color: white;">ระบบกำลังส่งท่านกลับไปยังห้องสนทนา</h4>
                </div>
        
                <div>
                <h4>
                    <a class="uk-link-text uk-text-primary" uk-icon="icon: link" (click)="closeLiff()">กลับไปยังห้องสนทนา</a>
                </h4>
                </div>
            </div>
				<div class="uk-container uk-container-small" *ngIf="complete() == 'false'">
					<div class="uk-card uk uk-card-body">
                        <h3 style="color: white;">สมัครใช้บริการ</h3>
                        <form autocomplete="off" #skyjourneyForm="ngForm" class="uk-margin-small-bottom uk-text-left" novalidate>
                            <div>
                                <label for="firstName" class="uk-form-label" style="color: white;">ชื่อ</label>
                                <div class="uk-form-controls uk-position-relative">
                                    <input id="firstName" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุชื่อของท่าน"
                                        autocomplete="off" name="firstName" #firstName="ngModel" [(ngModel)]="model().form.firstName.value"
                                        [(ngModel)]="model().form.firstName.value" [ngClass]="addClass(skyjourneyForm,'firstName')"
                                        [pattern]="regName" required />
                                    <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error" tabindex="-1"
                                        [ngClass]="addClass(skyjourneyForm,'firstName','msg')" *ngIf="firstName.errors">
                                        <span *ngIf="firstName.errors.required">กรุณาระบุชื่อของท่าน</span>
                                        <span *ngIf="firstName.errors && firstName.errors.pattern">ชื่อของคุณไม่ถูกหลัก</span>
                                    </small>
                                </div>
                            </div>
                            <div>
                                <label for="lastName" class="uk-form-label" style="color: white;">นามสกุล</label>
                                <div class="uk-form-controls uk-position-relative">
                                    <input id="lastName" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุนามสกุลของท่าน"
                                        autocomplete="off" name="lastName" #lastName="ngModel"
                                        [(ngModel)]="model().form.lastName.value" [ngClass]="addClass(skyjourneyForm,'lastName')"
                                        [pattern]="regName" required />
                                    <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error" tabindex="-1"
                                        [ngClass]="addClass(skyjourneyForm,'lastName','msg')">
                                        <span *ngIf="lastName.errors&& lastName.errors.required">กรุณาระบุนามสกุลของท่าน</span>
                                        <span *ngIf="lastName.errors && lastName.errors.pattern">นามสกุลของคุณไม่ถูกหลัก</span>
                                    </small>
                                </div>
                            </div>
                            <div>
                                <label for="id-card" class="uk-form-label" style="color: white;">เลขที่บัตรประจำตัวประชาชน</label>
                                <div class="uk-form-controls uk-position-relative">
                                    <input id="id-card" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุหมายเลขบัตรประชาชน"
                                        mask="0-0000-00000-00-0" autocomplete="off"
                                        name="idCard" #idCard="ngModel" [(ngModel)]="model().form.idcard.value"
                                        [ngClass]="addClass(skyjourneyForm,'idCard')" remoteValidator="validateIdCard"
                                        [validateFunction]="validateIdCard" debounce="0.1"
                                        required />
                                    <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                        tabindex="-1" [ngClass]="addClass(skyjourneyForm,'idCard','msg')" *ngIf="idCard.errors">
                                        <span *ngIf="idCard.errors.required">กรุณาระบุหมายเลขบัตรประชาชน</span>
                                        <span *ngIf="idCard.errors.validateIdCard">กรุณาระบุหมายเลขบัตรประชาชนให้ถูกต้อง</span>
                                    </small>
                                </div>
                            </div>
                            <div>
                                <label for="mobile" class="uk-form-label" style="color: white;">หมายเลขโทรศัพท์มือถือ</label>
                                <div class="uk-form-controls uk-position-relative">
                                    <input id="mobile" class="uk-input uk-border-rounded" type="text" placeholder="กรุณาระบุหมายเลขโทรศัพท์มือถือ"
                                        autocomplete="off" (keyup)="onKeyPress($event)" minlength="10" maxlength="10" inputmode="decimal"
                                        mask="0000000000" name="mobile" #mobile="ngModel" [(ngModel)]="model().form.mobile.value"
                                        [ngClass]="addClass(skyjourneyForm,'mobile')" [pattern]="regTel" debounce="5000" required />
                                    <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                        tabindex="-1" [ngClass]="addClass(skyjourneyForm,'mobile','msg')">
                                        <span *ngIf="mobile.errors&& mobile.errors.required">กรุณาระบุหมายเลขโทรศัพท์มือถือ</span>
                                        <span *ngIf="mobile.errors&&mobile.errors.pattern || mobile.errors&&mobile.errors.minlength">กรุณาระบุหมายเลขโทรศัพท์มือถือให้ถูกต้อง</span>
                                    </small>
                                </div>
                            </div>
                            <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
                                <button type="submit"
                                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                                    [disabled]="skyjourneyForm.invalid" (click)="onSubmit()">ถัดไป
                                </button>
                            </div>
                            <div class="uk-text-center" *ngIf="invalidInformation">
                                <p class="uk-text-center uk-text-meta uk-margin-small-bottom"><small>หากท่านต้องการแก้ไขข้อมูล
                                        กรุณาติดต่อ</small></p>
                                <div><a href="tel:026336060" class="uk-h5"><img src="/assets/images/icon-tel.svg" uk-svg class="tel-icon"
                                            width="15" height="15"> 0 2633 6060</a></div>
                            </div>
                        </form>
					</div>
				</div>
		</div>
	</div>
	<div class="uk-position-bottom-center uk-padding-small">
		<small class="uk-text-middle">© สงวนลิขสิทธิ์ 2562 บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด</small>
	</div>
	<app-loader *ngIf="(loader | async)"></app-loader>
</section>